import { render, staticRenderFns } from "./RecipeOffer.vue?vue&type=template&id=700b0706&"
import script from "./RecipeOffer.vue?vue&type=script&lang=js&"
export * from "./RecipeOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports